import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/apiClient";
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import UpdatePhotosCardDialog from "./UpdatePhotosCard";
import Loader from "../../Shared/Loader/Loader";
import { useCatchResponse } from '../../../utils/useCatchResponse';

const UpdatePhotosEntry = (props) => {
    const { catchResponse } = useCatchResponse();
    const [students, setStudents] = useState([]);
    const navigate = useNavigate();
    const [currentStudentIndex, setCurrentStudentIndex] = useState(0);

    useEffect(() => {
        GetStudentsList();
    }, []);

    const GetStudentsList = async () => {
        try {
            Loader.show();
            let data = {
                ClassId: props?.location?.state?.classId,
            };
            const response = await api.post(APIConstant.path.GetClassConfigStudentDetail, data);
            if (response.success) {
                setStudents(response?.data?.sort((a, b) => a?.RollNo - b?.RollNo));
            }
            Loader.hide();
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    };

    const handleNext = () => {
        if (currentStudentIndex < students.length - 1) {
            setCurrentStudentIndex(currentStudentIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentStudentIndex > 0) {
            setCurrentStudentIndex(currentStudentIndex - 1);
        }
    };

    const handleProfileUpdate = (studentId, original, preview) => {
        var formatedData = students.map((student) =>
            student?.id === studentId
                ? {
                    ...student,
                    ProfilePhotoUrl: original,
                    PreviewProfilePhotoUrl: preview
                }
                : student
        );
        console.log('dfhdhdh: ', formatedData);

        setStudents([...formatedData]);
    };

    const UpdateBulkProfilePhoto = async () => {
        if (!students || students.length === 0) return;

        try {
            const formData = new FormData();
            const studentList = [];

            students.forEach((student) => {
                const profilePicPath = student?.ProfilePhotoUrl;
                const studentId = student?.id;

                let fileName = "";

                if (profilePicPath && typeof profilePicPath !== "string") {
                    const extension = profilePicPath.name ? getExtensionFromFileName(profilePicPath.name) : 'jpg';
                    formData.append("bulkProfilePic", profilePicPath, `${studentId}.${extension}`);
                    // formData.append("bulkProfilePic", profilePicPath);
                } else {
                    fileName = profilePicPath ? profilePicPath.split('/').pop() : "";
                }

                studentList.push({
                    id: studentId,
                    ProfilePhotoUrl: fileName,
                });
            });

            formData.append("Students", JSON.stringify(studentList));
            Loader.show();
            const response = await api.post(
                APIConstant.path.UpdateBulkProfilePhoto,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            Loader.hide();
            const res = response;
            if (res?.success) {
                Toast.success({ message: res.message });
                navigate(-1);
            } else {
                Toast.error({ message: res.message || "Failed to update profile photos" });
            }
        } catch (error) {
            Loader.hide();
            Toast.error({ message: "Something went wrong" });
            console.error("Upload error: ", error);
        }
    };

    function getExtensionFromFileName(fileNameOrUrl) {
        if (!fileNameOrUrl) return 'jpg';

        const cleanName = fileNameOrUrl.split('?')[0];

        const parts = cleanName.split('.');
        if (parts.length === 1) return 'jpg';

        const ext = parts.pop().toLowerCase();

        if (ext.length >= 2 && ext.length <= 5) return ext;

        return 'jpg';
    }


    return (
        <div className="wayment-owner-dashboard e-weighment-dashboard">
            <div className="heading-area flex justify-between items-center">
                <div className="flex items-center">
                    <i className="pi pi-arrow-left" onClick={() => navigate(-1)}></i>
                    <h2 className="ml-2">{props?.location?.state?.className}</h2>
                </div>
            </div>
            <hr />
            {students.length > 0 && (
                <UpdatePhotosCardDialog student={students[currentStudentIndex]} onProfileChange={handleProfileUpdate} />
            )}
            <div className="flex justify-between mt-4">
                <Button
                    label="Previous"
                    className="p-button-secondary"
                    onClick={handlePrevious}
                    disabled={currentStudentIndex === 0}
                />
                <div className="flex justify-end gap-3 mt-4">
                    <Button label="Cancel" onClick={(e) => navigate(-1)} className="p-button-outlined p-button-secondary" />
                    <Button label="Submit All" className="p-button-primary" onClick={(e) => UpdateBulkProfilePhoto()} />
                </div>
                <Button
                    label="Next"
                    className="p-button-secondary"
                    onClick={handleNext}
                    disabled={currentStudentIndex === students.length - 1}
                />
            </div>
        </div>
    );
};

export default UpdatePhotosEntry;
